import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from './getOrganization';
import type { Sector } from '../../types';

export const sector = createSelector(getOrganization, function (organization): Sector {
  if (organization === undefined) return 'OTHER';
  return organization.sector;
});
